import { makeRequest } from 'utils/requestLogger';

export default (submissionID) =>
  makeRequest('put', `/api/submissions/${submissionID}/toggle-model-response`);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/submission/toggleModelResponse.js